import React, { useState, useEffect } from "react";
import AdminDashboardLayout from "../../components/layout/AdminDashboardLayout";
import AgentDashboard from "../../dashboard/agent-dashboard/AgentDashboard";
import Layout from "../../components/layout/Layout";
const AgentDashboardMain = () => {
  const [navParams, setNavParams] = useState({
    navTitle: "Agent Dashboard",
    navSubTitle: "Welcome to Easy Property Dashboard",
  });

  useEffect(() => { }, []);
  return (
    // <Layout hideFooter={true} >
    <AdminDashboardLayout
      navTitle={navParams.navTitle}
      navSubTitle={navParams.navSubTitle}
    >
      <AgentDashboard />
    </AdminDashboardLayout>
    // </Layout >
  );
};

export default AgentDashboardMain;
